import { ETime } from '@common/enums';

export const dateTimeUnitMap = {
    [ETime.days]: 1,
    [ETime.hours]: 2,
    [ETime.minutes]: 3,
    [ETime.seconds]: 4,
};
